import bundledCountries from "./assets/countriesminified.json"
import bundledStates from "./assets/statesminified.json"

/**
 * Country and state/province data from bundled JSON assets (replaces react-country-state-city).
 */

/** @returns {{ id: number, name: string, iso2?: string, iso3?: string, hasStates?: boolean }[]} */
export function getCountriesList() {
    return Array.isArray(bundledCountries) ? bundledCountries : []
}

/** @param {number} countryId @returns {{ id: number, name: string, state_code: string }[]} */
export function getStatesList(countryId) {
    if (!countryId) return []
    const entry = Array.isArray(bundledStates)
        ? bundledStates.find((x) => x?.id === countryId)
        : null
    const states = entry?.states
    return Array.isArray(states) ? states : []
}

/**
 * @param {string} countryName
 * @param {{ id: number, name: string }[]} [countries]
 */
export function getStatesListForCountryName(countryName, countries = getCountriesList()) {
    const c = countries.find((x) => x.name === countryName)
    return c ? getStatesList(c.id) : []
}

/** @returns {Promise<ReturnType<typeof getCountriesList>>} */
export function fetchCountries() {
    return Promise.resolve(getCountriesList())
}

/** @param {number} countryId */
export function fetchStates(countryId) {
    return Promise.resolve(getStatesList(countryId))
}
